import React, { useContext, useEffect, useState } from "react";
import EstimateContent from "../content/estimateContent";
import { UserContext } from "../../App";
import { getStripeOnboardingLink } from "../../store/actions/stripeActions";
import { useHistory } from "react-router-dom";
import Layout from "../layout/Layout";

const Estimate = () => {
  const { userInfos, loading } = useContext(UserContext);
  const history = useHistory();

  const [init, setInit] = useState(false);

  useEffect(() => {
    if (!loading && userInfos && userInfos.jwt) {
      getStripeOnboardingLink(userInfos.jwt).then((response) => {
        if (response.data) {
          if (userInfos.createdBy) {
            window.alert(
              "Votre administrateur n'a pas encore terminé le processus d'intégration de Stripe. Veuillez contacter votre administrateur pour terminer le processus."
            );
            history.push("/");
          } else {
            window.location.href = response.data;
          }
        } else {
          setInit(true);
        }
      });
    }
  }, [history, loading, userInfos]);

  return <Layout>{init && <EstimateContent />}</Layout>;
};

export default Estimate;
